module.exports = __webpack_public_path__ + "_/assets/images/icons/icon-banner-f79727d192648ad6336b83736be06309.svg";